import type { CityConfig } from "../city-template/types";

export const dallasConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Dallas",
  state: "Texas",
  stateAbbr: "TX",
  slug: "dallas",
  route: "/cities/dallas",
  title: "Emergency Passport Dallas, TX — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Dallas, TX — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Dallas business travelers, DFW airport passengers, university students, and North Texas families.",
  h1: "Emergency & Expedited Passport Services in Dallas, TX",
  heroSubtitle: "DFW International flight to Tokyo departing in two weeks? International business deal closing in Dubai? SMU or UTD study-abroad program starting in Barcelona? We help Dallas residents — from Uptown executives to Plano families to Irving logistics professionals — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20panoramic%20view%20of%20downtown%20Dallas%20Texas%20skyline%20at%20golden%20hour%20with%20the%20Reunion%20Tower%20and%20modern%20glass%20skyscrapers%20reflecting%20warm%20sunset%20light%2C%20elevated%20view%20over%20the%20Trinity%20River%20with%20green%20trees%2C%20professional%20architectural%20photography%20with%20rich%20warm%20tones%20and%20dramatic%20clouds%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=dallas-hero-2026&orientation=landscape",
  heroImageAlt: "Dallas Texas downtown skyline with Reunion Tower at golden hour",
  geoPosition: "32.7767;-96.7970",
  geoPlacename: "Dallas, Texas",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "Dallas Passport Agency",
    address: "300 Commerce St, Suite 100, Dallas, TX 75242",
    distance: "Located in downtown Dallas at 300 Commerce St — visit in person for life-or-death emergencies, appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Dallas", zips: "75201–75270, 75301–75398" },
    { name: "Plano", zips: "75023, 75024, 75025, 75026, 75074, 75075, 75086, 75093, 75094" },
    { name: "Irving", zips: "75014, 75015, 75016, 75017, 75038, 75039, 75060, 75061, 75062, 75063" },
    { name: "Garland", zips: "75040, 75041, 75042, 75043, 75044, 75045, 75046, 75049" },
    { name: "Frisco", zips: "75033, 75034, 75035, 75036" },
    { name: "McKinney", zips: "75069, 75070, 75071" },
    { name: "Arlington", zips: "76001–76018" },
    { name: "Richardson", zips: "75080, 75081, 75082, 75083, 75085" },
    { name: "Carrollton", zips: "75006, 75007, 75010, 75011" },
    { name: "Mesquite", zips: "75149, 75150, 75181" },
    { name: "Denton", zips: "76201–76210" },
    { name: "Allen", zips: "75002, 75013" },
    { name: "Grand Prairie", zips: "75050, 75051, 75052, 75053, 75054" },
    { name: "Fort Worth", zips: "76101–76199" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour DFW Emergency Processing", desc: "Reserved courier access to the Dallas Passport Agency — as fast as 24 hours for DFW-area travelers with immediate departures." },
    { icon: "ri-flight-takeoff-line", title: "DFW Airport Expertise", desc: "230+ international destinations from DFW. We know airline timelines, American Airlines hub dynamics, and last-minute boarding scenarios." },
    { icon: "ri-building-2-line", title: "Corporate Travel Ready", desc: "Fortune 500 companies, short-notice international trips, deal-closing travel — we handle the passport so you handle the business." },
    { icon: "ri-graduation-cap-line", title: "University + Family Expedited", desc: "SMU, UTD, TCU, UNT students studying abroad; North Texas families booking first international vacations — we guide everyone through." },
  ],
  internalLinks: [
    { name: "Fast passport services in Houston, TX", route: "/cities/houston" },
    { name: "Expedited passport in Austin, TX", route: "/cities/austin" },
    { name: "Quick passport services in Fort Worth, TX", route: "/cities/fort-worth" },
    { name: "Urgent passport services in Plano, TX", route: "/cities/plano" },
    { name: "Texas passport services overview", route: "/states/texas" },
  ],
  fpcOfficeAddress: "1919 Smith St, Suite 1400, Houston, TX 77002",
  fpcOfficeNote: "Fast Passport Center serves Dallas via secure registered courier with direct access to the Houston Passport Agency at 1919 Smith St, Suite 1400. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Dallas residents can ship from any UPS Store, FedEx Office, or post office location across the Metroplex.",
  fpcOfficeDistance: "Serving Dallas, Plano, Irving, Garland, Frisco, McKinney, Richardson, and all DFW Metroplex communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Dallas and the greater Dallas-Fort Worth Metroplex. From the downtown business district to the northern suburbs of Plano, Frisco, and McKinney, from the eastern communities of Garland and Mesquite to Irving and Las Colinas — we serve all of Dallas County, Collin County, Denton County, and Tarrant County. Our courier service eliminates the need to drive downtown and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Dallas and all DFW Metroplex communities including Plano, Irving, Garland, Frisco, McKinney, Richardson, Carrollton, Mesquite, Denton, Allen, Grand Prairie, Arlington, and Fort Worth. We also serve travelers departing from DFW International Airport and Dallas Love Field who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Dallas as simple as possible — with the efficiency and reliability DFW executives, North Texas families, and university students need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Dallas travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Dallas travelers encounter unique passport issues — everything from DFW same-day bookings to 6-month validity rules for Asian destinations. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Dallas travelers — from Uptown executives to Plano families to Frisco tech workers — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Dallas, TX? Here are the most common ones we hear from DFW-area travelers.",
  statePageRoute: "/states/texas",
  statePageName: "Texas",
  servicesIntro: "Whether you need a renewal before a DFW flight to London, an emergency passport for a last-minute corporate trip, or a first-time passport for a DFW-area family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.dallascounty.org/departments/tax/",
  dmvLabel: "Dallas County Tax Office — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    { speed: "2–9", unit: "Business Days", label: "Fast Passport Center", tag: "Most Popular", tagColor: "bg-[#F6C344] text-[#1A365D]", features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"], highlight: true },
    { speed: "3–5", unit: "Weeks", label: "Fast Passport Center", tag: "Standard Expedited", tagColor: "bg-[#1A365D]/10 text-[#1A365D]", features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"], highlight: false, smartSaver: true },
    { speed: "1–2", unit: "Months", label: "Self-Service (Post Office)", tag: "Slowest", tagColor: "bg-gray-100 text-gray-400", features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"], highlight: false, muted: true },
    { speed: "24", unit: "Hours*", label: "Regional Agency Processing", tag: "Emergency Only", tagColor: "bg-gray-100 text-gray-500", features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"], highlight: false, emergency: true },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "DFW flight to Tokyo in two days? International deal closing in Dubai this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Dallas-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Dallas residents renew fast — no agency visit required for most renewals. Perfect for DFW-area executives, Plano families, and Irving professionals preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Dallas residents through every step — from Uptown to Frisco to Irving — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your DFW international connection or overseas business trip is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family vacation or North Texas family trip abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Dallas professionals after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Dallas corporate executives, tech workers, and consultants who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide DFW-area travelers through the process so your international itinerary or corporate travel stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Dallas TX", description: "Urgent passport processing for Dallas Texas travelers with immediate departure needs from DFW Airport." },
    { name: "Expedited Passport Renewal Dallas TX", description: "Fast passport renewal for Dallas Texas residents with a previously-issued passport." },
    { name: "First-Time Passport Dallas TX", description: "New passport application services for Dallas Texas residents applying for their first passport." },
    { name: "Child Passport Dallas TX", description: "Minor passport services for Dallas Texas families with children under 16." },
    { name: "Name Change Passport Dallas TX", description: "Passport name correction after marriage, divorce, or legal name changes for Dallas residents." },
    { name: "Second Passport Dallas TX", description: "Second passport services for Dallas corporate executives and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Kevin A.",
      location: "Uptown Dallas",
      rating: 5,
      text: "My company booked me to London in 9 days and my passport was expired. Fast Passport Center got it back in 48 hours. The document review was thorough and they caught an issue I never would have noticed.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Kim Family",
      location: "Plano",
      rating: 5,
      text: "We booked a last-minute trip to Seoul and realized our daughter's passport expired two months ago. They walked us through everything and the passport arrived in 5 days. Incredible service.",
      service: "Child Passport Renewal",
    },
    {
      name: "Maria G.",
      location: "Irving",
      rating: 5,
      text: "I needed a name change on my passport before a conference in Madrid. They handled the entire process remotely — I never had to visit an office. Smooth and fast.",
      service: "Name Change Passport",
    },
    {
      name: "David L.",
      location: "Frisco",
      rating: 5,
      text: "Third time using Fast Passport Center for DFW-to-Japan business trips. They know exactly what to do and the timeline is always accurate. Won't use anyone else.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "dallas-1",
      name: "Dallas Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "400 N Ervay St",
      city: "Dallas",
      state: "TX",
      zip: "75201",
      phone: "(214) 760-4536",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Dallas",
      website: "https://tools.usps.com/find-location.htm?location=1367618",
      websiteLabel: "USPS Location",
      notes: "Downtown Dallas location, passport acceptance services by appointment. Photo services on-site. Busiest facility in central Dallas — book early.",
      icon: "ri-mail-line",
    },
    {
      id: "dallas-2",
      name: "Oak Lawn Station Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3730 Cedar Springs Rd",
      city: "Dallas",
      state: "TX",
      zip: "75219",
      phone: "(214) 521-6001",
      hours: "Mon–Fri 9:00 AM – 4:00 PM, walk-ins available",
      distance: "Oak Lawn / Uptown area",
      website: "https://tools.usps.com/find-location.htm?location=1377543",
      websiteLabel: "USPS Location",
      notes: "Convenient for Uptown and Oak Lawn residents. Passport photos available. Walk-in hours subject to clerk availability — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "dallas-3",
      name: "Lakewood Branch Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2345 Abrams Rd",
      city: "Dallas",
      state: "TX",
      zip: "75214",
      phone: "(214) 821-4747",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Lakewood / East Dallas",
      website: "https://www.dallascounty.org/departments/districtclerk/passports.php",
      websiteLabel: "Dallas County Clerk",
      notes: "Serves Lakewood, M Streets, and East Dallas neighborhoods. Limited appointment slots — schedule at least a week in advance during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "dallas-4",
      name: "Collin County Clerk — McKinney",
      type: "County Clerk Passport Acceptance",
      address: "2300 Bloomdale Rd",
      city: "McKinney",
      state: "TX",
      zip: "75071",
      phone: "(972) 548-4185",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "McKinney — Collin County",
      website: "https://www.collincountytx.gov/county_clerk/Pages/passports.aspx",
      websiteLabel: "Collin County Clerk",
      notes: "Primary acceptance facility for Collin County residents including Plano, Frisco, Allen, and McKinney. Appointment recommended. No photo services on-site.",
      icon: "ri-government-line",
    },
    {
      id: "dallas-5",
      name: "Plano Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1900 E Spring Creek Pkwy",
      city: "Plano",
      state: "TX",
      zip: "75074",
      phone: "(972) 423-9701",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Plano — Collin County",
      website: "https://tools.usps.com/find-location.htm?location=1377577",
      websiteLabel: "USPS Location",
      notes: "Serves Plano, Richardson, and North Dallas suburbs. Passport photos available. Saturday appointments may be available — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "dallas-6",
      name: "Irving Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 Main St",
      city: "Irving",
      state: "TX",
      zip: "75061",
      phone: "(972) 721-2407",
      hours: "Mon–Fri 9:00 AM – 4:00 PM, walk-ins available",
      distance: "Irving — near DFW Airport",
      website: "https://tools.usps.com/find-location.htm?location=1387618",
      websiteLabel: "USPS Location",
      notes: "Convenient for Irving, Las Colinas, and DFW Airport-area residents. Walk-in capacity limited — arrive early for best availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Houston Passport Agency (~240 mi each way via I-45)", fpc: "Most DFW travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "DFW-Specific Guidance", agency: "Generic — no DFW airport, corporate travel, or university expertise", fpc: "Full DFW/corporate/SMU-UTD/university knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming DFW Agency Takes Walk-Ins",
      description: "The Dallas Passport Agency requires appointments even for emergencies. Many Dallas residents arrive without an appointment and are turned away. Our courier channel bypasses this entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Dallas applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Dallas pharmacies and big-box stores produce photos that fail State Department standards. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "North Texas families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule",
      description: "Dallas travelers booking to Japan, Southeast Asia, or Europe often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Dallas clients ship from home — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive to Atlanta or wait at the Dallas Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Dallas?", a: "We offer Dallas-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Dallas office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (a Dallas post office or county clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Dallas address." },
    { q: "Where can I get a passport acceptance in Dallas?", a: "Dallas has acceptance facilities at many post offices (downtown, Uptown, Oak Lawn, Lakewood, Preston Hollow) as well as Collin County and Dallas County clerk offices. We maintain an updated list of Dallas-area facilities with hours, photo availability, and appointment options." },
    { q: "Does the Dallas Passport Agency handle walk-ins?", a: "The Dallas Passport Agency (located in downtown Dallas) requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel without agency restrictions." },
    { q: "What is the best price for expedited passport service in Dallas?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "What documents do Dallas applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Dallas-specific checklist." },
    { q: "Can I get a passport photo in Dallas?", a: "Yes — many Dallas post offices, CVS, Walgreens, UPS Stores, and AAA offices offer passport photos. We recommend confirming photo standards compliance before visiting. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How do I check my Dallas passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Dallas to final return shipping typically matches your chosen speed tier." },
    { q: "Is Dallas near a passport agency?", a: "The Dallas Passport Agency is located at 300 Commerce St, Suite 100, Dallas, TX 75242. However, it only serves travelers with life-or-death emergencies. For standard expedited needs — even urgent ones — our courier channel is faster and more accessible than agency appointments." },
    { q: "Can you help with passports for DFW International Airport travel?", a: "Yes. DFW is one of the world's busiest international airports, and we regularly assist Dallas travelers with expedited passports for international departures. We understand the DFW corridor — from Arlington to Plano to Irving — and can coordinate timelines around your departure." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Dallas Residents",
    intro: "Dallas-Fort Worth's unique position as a global aviation hub and corporate powerhouse creates distinct passport timing challenges. Here's what Dallas travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "DFW — Dallas-Fort Worth International Airport",
        subtitle: "World's 4th busiest airport, American Airlines primary hub",
        description: "DFW handles more than 73 million passengers annually with direct flights to London, Tokyo, Cancun, Paris, Frankfurt, and 230+ destinations. American Airlines' massive hub operation means DFW connects North Texas to virtually every international market. The airport's global reach creates regular passport urgencies — executives booking last-minute international trips, families with expired passports, and students heading abroad for study programs.",
        tip: "American Airlines' international award travel often gets booked months in advance — then passengers realize their passport expires during the trip. Check validity the moment you book, not when you pack.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "DAL — Love Field (Southwest Airlines)",
        subtitle: "Dallas Love Field, domestic + limited international service",
        description: "Love Field serves Dallas intown neighborhoods — Uptown, Oak Lawn, Highland Park — with Southwest flights. Many Dallas residents choose Love Field for domestic connections to international gateways like Miami, Houston, or Atlanta. The convenience of Love Field sometimes creates a false sense of travel flexibility — a missed connection at IAH due to a passport issue can cascade quickly.",
        tip: "If you are connecting through another U.S. hub to fly internationally, you still need a valid passport at your point of departure in Dallas.",
      },
      {
        icon: "ri-building-2-line",
        title: "Corporate Travel & Fortune 500 Demand",
        subtitle: "American Airlines, AT&T, ExxonMobil, Southwest Airlines, Toyota",
        description: "Dallas-Fort Worth hosts more Fortune 500 companies per capita than almost any metropolitan area in the United States. American Airlines alone moves thousands of employees internationally each year. When corporate travel plans surface on short timelines — quarterly board meetings in London, annual conferences in Tokyo, global training programs in Germany — passport processing urgencies emerge that standard post office services cannot handle.",
        tip: "Dallas corporate travelers often book through company travel desks that do not flag passport expiration. Always self-check your passport validity, especially for any trip to a country requiring 6 months beyond return date.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "University Study Abroad & Student Travel",
        subtitle: "UT Dallas, SMU, TCU, UNT, UTA, Dallas colleges",
        description: "The DFW metroplex has one of the largest concentrations of university students in the country. SMU, UT Dallas, TCU, UNT, UTA, and Richland College collectively send thousands of students abroad each year for semester exchange, summer programs, and spring break immersions. Many of these students — especially first-generation college students — have never had passports. The acceptance-to-orientation pipeline is often 6–10 weeks, requiring expedited processing to meet program start dates.",
        tip: "First-time applicants in Dallas must visit an acceptance facility in person. We guide students through the nearest facility with the earliest available appointment, so they do not miss their program orientation.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Dallas & Cross-Border Mexico Travel",
      description: "Dallas has a large and growing Hispanic population with strong family ties to Mexico. Weekend trips to Monterrey, holiday visits to family hometowns, and medical tourism to Mexican border cities create a constant stream of passport urgencies — especially for extended family members who have never traveled internationally before.",
    },
  },
  destinations: {
    title: "Where Dallas Travelers Go — And Why Passports Get Urgent",
    intro: "DFW's global reach means Dallas travelers need passports for destinations spanning six continents. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "42%", label: "of Dallas expedited requests are corporate or business-related with under 2 weeks notice" },
      { stat: "2–4 Weeks", label: "average lead time Dallas travelers have from trip booking to international departure" },
      { stat: "Jan–Mar", label: "peak season when spring break, corporate Q1 travel, and study abroad deadlines collide" },
      { stat: "36 Hours", label: "shortest turnaround we have accommodated for a DFW executive departing to London" },
    ],
    destinations: [
      { name: "Mexico", context: "Family heritage trips, Cancun and Riviera Maya resorts, Monterrey business, medical dental tourism", urgency: "Spring break bookings peak January through March", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "American Airlines direct flights to London Heathrow, corporate meetings, heritage travel", urgency: "Business trips booked 2–3 weeks out with fixed meeting dates", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "American Airlines DFW-Tokyo direct flight, Samsung and LG supplier meetings, tech industry travel", urgency: "Tech deal travel often has 1–2 week booking-to-departure windows", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "DFW-Frankfurt direct route, auto industry suppliers, Texas Manufacturing Assistance Center connections", urgency: "Industry conference and trade show dates are fixed and unmovable", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Bahamas", context: "Galveston and Miami cruise departures, family vacation packages, spring break resort bookings", urgency: "Last-minute cruise deals and all-inclusive packages booked 3–4 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Dallas-to-Toronto business travel, Niagara Falls family trips, Vancouver tech industry connections", urgency: "Cross-border business bookings often 1–2 weeks out", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Texas Service Areas",
    crossLinksDesc: "We serve travelers across the Lone Star State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Houston", route: "/cities/houston" },
      { name: "Austin", route: "/cities/austin" },
      { name: "Fort Worth", route: "/cities/fort-worth" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Uptown", address: "2505 McKinney Ave, Dallas, TX 75201", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Oak Lawn", address: "3524 McKinney Ave, Dallas, TX 75204", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Lakewood", address: "6333 E Mockingbird Ln, Dallas, TX 75214", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "The UPS Store — Preston Center", address: "6025 Royal Ln, Dallas, TX 75230", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Walgreens — Highland Park", address: "5200 Lemmon Ave, Dallas, TX 75209", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Preston Hollow", address: "10720 Preston Rd, Dallas, TX 75230", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "FedEx Office — Downtown Dallas", address: "555 S Lamar St, Dallas, TX 75202", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
    { name: "Walgreens — Plano", address: "6205 Coit Rd, Plano, TX 75024", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
  ],
  dmvLocations: [
    {
      name: "Dallas County Tax Office — Downtown",
      address: "500 Elm St, Dallas, TX 75202",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Texas DPS — Garland Mega Center",
      address: "4445 Saturn Rd, Garland, TX 75041",
      hours: "Mon–Fri, 7:30 AM – 6:00 PM",
      note: "Full-service DPS driver license office. REAL ID available. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DFW",
      name: "Dallas-Fort Worth International Airport",
      distance: "About 20 miles from downtown Dallas",
      address: "2400 Aviation Dr, DFW Airport, TX 75261",
      note: "World's 4th busiest airport. American Airlines global hub with nonstop service to 230+ destinations including London, Tokyo, Paris, Frankfurt, and Seoul.",
      flightUrl: "https://www.dfwairport.com/",
      flightLabel: "DFW Airport Website",
      featured: true,
    },
    {
      code: "DAL",
      name: "Dallas Love Field Airport",
      distance: "About 6 miles from downtown Dallas",
      address: "8008 Herb Kelleher Way, Dallas, TX 75235",
      note: "Southwest Airlines hub serving domestic connections to international gateways. Convenient for Uptown and downtown Dallas residents.",
      flightUrl: "https://www.dallas-lovefield.com/",
      flightLabel: "Love Field Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Texas Department of State Health Services. Online, mail, or in-person options available for Dallas County.",
      url: "https://www.dshs.texas.gov/vs/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Texas DSHS Vital Statistics. Required for estate and legal matters in Dallas County.",
      url: "https://www.dshs.texas.gov/vs/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Dallas County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.dallascounty.org/departments/countyclerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Dallas County District Clerk. Required for name change passport corrections.",
      url: "https://www.dallascounty.org/departments/districtclerk/",
    },
  ],
};